import indonesianMessages from "ra-language-indonesian"
import localeId from "./bahasa"

export default {
  ...indonesianMessages,
  resources: {
    ...localeId,
  },
}
